import { getTZOffset } from 'plugin/src/shared/Utils'
import { getBasicClassroomInfo } from 'plugin/src/shared/classroom/classroomInfo'
import { DiagnosticsLogger } from '@mote/helpers'
import {
  getContainingUrlFromActiveTab,
  isInExtension
} from '@mote/helpers/extension'
import { getExtensionVersion } from '@mote/helpers/extension'
import { apiClient } from '../../../client'

const logD = new DiagnosticsLogger('NetworkLayer', 'ToteRegistration')

/**
 * @param {Object} payload
 * @return {Promise<string | null>}
 */
export async function registerTote(payload = { variables: {} }) {
  let json = {
    containingURL: window.location.href,
    TZOffset: getTZOffset()
  }

  //TODO: this should live in `plugin` directory api should NEVER know about context in which is currently being used
  if (isInExtension()) json.clientVersion = `extension:${getExtensionVersion()}`

  json = await injectDynamicPayload(json)

  try {
    /**
     * @type {{toteStatus: ToteStatus}}
     */
    const data = await apiClient
      .post('v1/t/register', {
        json: {
          ...json,
          ...payload.variables
        }
      })
      .then(response => response.json())
    logD.info('Tote registered successfully ID.', data.toteStatus.toteId)
    return data.toteStatus.toteId
  } catch (error) {
    logD.error('Tote registration error.', { error })
    throw error
  }
}

async function injectDynamicPayload(payload = {}) {
  if (isInExtension()) {
    payload.containingURL = await getContainingUrlFromActiveTab()
    const classroomData = getBasicClassroomInfo()
    for (const classroomProperty in classroomData) {
      payload[classroomProperty] = classroomData[classroomProperty]
    }
  }

  return payload
}
